import { Link } from "react-router-dom";

/* Page 404 — le <meta robots="noindex"> est géré par RouteSEO (App.js) */
export default function NotFound() {
  return (
    <main
      className="NotFound"
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "140px 24px 80px",
        gap: "18px",
      }}
    >
      <h1 style={{ fontWeight: 300, letterSpacing: "0.08em" }}>Page introuvable</h1>
      <p style={{ maxWidth: 520, lineHeight: 1.7 }}>
        La page que vous cherchez n'existe pas ou a été déplacée. Découvrez nos
        réalisations sur mesure :
      </p>
      <nav style={{ display: "flex", flexWrap: "wrap", gap: "12px 24px", justifyContent: "center" }}>
        <Link to="/collections/cuisines">Cuisines sur mesure</Link>
        <Link to="/collections/dressings">Dressings</Link>
        <Link to="/export/projets-international">Projets internationaux</Link>
        <Link to="/contact">Contact</Link>
      </nav>
    </main>
  );
}
